import request from '../utils/request'

const base = 'order'

/**
 * @method getFolio
 * @param {String} folio - Folio
 * @param {Number} v - API Version
 */

export function getFolio(folio, ws, v) {
  return request({
    url: `/v${v || 1}/${base}/${folio}`,
    method: 'get',
    params: {
      ws: ws
    }
  })
}

/**
 * @method sendRate
 * @param {Object} data
 * @property {Number} rate
 * @property {String} comment
 * @param {String} folio
 * @param {Number} v
 * @returns {Promise}
 */

export function sendRate(data, folio, v) {
  return request({
    url: `/v${v || 1}/${base}/${folio}/rate`,
    method: 'post',
    data
  })
}

/**
 * @typedef {Object} FoliosByPhone
 * @property {String} folio
 * @property {String} createdAt
 * @property {String} updatedAt
 */

/**
 * @method searchByPhone
 * @param {Object} phone - {phone: String, countryCode: String}
 * @param {Number} v - API Version
 * @returns {Promise<Array<FoliosByPhone>>}
 */

export function searchByPhone(phone, v) {
  return request({
    url: `/v${v || 1}/${base}/phone`,
    method: 'get',
    params: phone
  })
}

/**
 * @method getLocationExternal
 * @param {String} folio - folio
 * @param {Number} v - API Version
 * @returns {Promise}
 */

export function getLocationExternal(folio, v) {
  return request({
    url: `/v${v || 1}/order/${folio}/location`,
    method: 'get'
  })
}
